import React, { useMemo } from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import Skeleton from 'react-loading-skeleton';
import { localeStore } from 'src/mobx/localesStore';
import { sidebarStore } from 'src/mobx/sidebarStore';
import { userStore } from 'src/mobx/userStore';
import LogoutButton from 'src/view/containers/LogoutButton/LogoutButton';
import './style.scss';

const UserInfo: React.FC = observer((): JSX.Element | null => {
  const userRole = useMemo(
    () => <p className="user-info__role text-elipsis">{localeStore.t(userStore.user?.role) || <Skeleton width={40} />}</p>,
    [userStore.user?.role, localeStore.loading]
  );

  if (!userStore.user || !sidebarStore.isOpen) return null;

  return (
    <div className={classNames('user-info animate__faster animate__animated', { animate__fadeInLeft: sidebarStore.isOpen })}>
      <div className="user-info__text-wrapper">
        <p className="user-info__name text-elipsis">
          {userStore.user.id ? userStore.user?.name || userStore.user?.email || '' : <Skeleton width={100} />}
        </p>
        {userRole}
      </div>
      <LogoutButton />
    </div>
  );
});

export default UserInfo;
